<div class="calls">
  <app-page-title icon="fa-phone" [title]="title">
    <button class="btn btn-secondary" (click)="back()">Voltar</button>
  </app-page-title>

  <!-- Tabs -->
  <ul class="nav nav-tabs mb-3">
    <li class="nav-item">
      <a class="nav-link"
         [class.active]="activeTab === 'automation'"
         (click)="onTabChange('automation')"
         style="cursor: pointer;">
        Automação
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link"
         [class.active]="activeTab === 'broadcast'"
         (click)="onTabChange('broadcast')"
         style="cursor: pointer;">
        Broadcast
      </a>
    </li>
  </ul>

  <app-skeleton *ngIf="loading" variant="table-row" [count]="6" [columns]="5"
    label="Carregando as ligações do dia" data-testid="calls-loading"></app-skeleton>

  <!-- Automation Tab Content -->
  <div *ngIf="!loading && activeTab === 'automation'">
    <div *ngIf="result?.data?.length > 0; else notFound">
      <app-accordion-panel
        *ngFor="let call of result?.data"
        [title]="call.campaign_name || 'Ligação'"
      >
        <div class="row message-line">
          <div class="col-md-2 col-sm-12"><i class="fa fa-user me-2"></i>{{ call.name || 'Sem nome' }}</div>
          <div class="col-md-2 col-sm-12"><i class="fa fa-phone me-2"></i>{{ call.phone }}</div>
          <div class="col-md-3 col-sm-12"><i class="fa fa-calendar me-2"></i>{{ call.sent_at | date:'dd/MM/yyyy HH:mm' }}</div>
          <div class="col-md-2 col-sm-12"><i class="fa fa-info-circle me-2"></i>{{ formatPabxStatus(call.pabx_status) }}</div>
          <div class="col-md-2 col-sm-12"><i class="fa fa-clock-o me-2"></i>{{ formatDuration(call.call_duration_seconds) }}</div>
        </div>
      </app-accordion-panel>
    </div>
  </div>

  <!-- Broadcast Tab Content -->
  <div *ngIf="!loading && activeTab === 'broadcast'">
    <div *ngIf="broadcastResult?.data?.length > 0; else notFound">
      <app-accordion-panel
        *ngFor="let call of broadcastResult?.data"
        [title]="call.broadcast_name || 'Broadcast'"
      >
        <div class="row message-line">
          <div class="col-md-2 col-sm-12"><i class="fa fa-user me-2"></i>{{ call.name || 'Sem nome' }}</div>
          <div class="col-md-2 col-sm-12"><i class="fa fa-phone me-2"></i>{{ call.phone }}</div>
          <div class="col-md-3 col-sm-12"><i class="fa fa-calendar me-2"></i>{{ call.sent_at | date:'dd/MM/yyyy HH:mm' }}</div>
          <div class="col-md-2 col-sm-12"><i class="fa fa-info-circle me-2"></i>{{ formatPabxStatus(call.pabx_status) }}</div>
          <div class="col-md-2 col-sm-12"><i class="fa fa-clock-o me-2"></i>{{ formatDuration(call.call_duration_seconds) }}</div>
        </div>
      </app-accordion-panel>
    </div>
  </div>

  <ng-template #notFound>
    <div class="card">
      Nenhuma ligação enviada
    </div>
  </ng-template>

  <app-pagination
    *ngIf="!loading && ((activeTab === 'automation' && result) || (activeTab === 'broadcast' && broadcastResult))"
    [currentPage]="activeTab === 'automation' ? result?.current_page : broadcastResult?.current_page"
    [itemsPerPage]="activeTab === 'automation' ? result?.per_page : broadcastResult?.per_page"
    [totalItems]="activeTab === 'automation' ? result?.total : broadcastResult?.total"
    (pageChanged)="pageChanged($event)"
  ></app-pagination>
</div>
